const bannerItems = document.querySelectorAll('.p-banner__items');
bannerItems.forEach((element, index) => {
  element.addEventListener('mouseover', (e) => {
    bannerItems.forEach((otherElement, otherIndex) => {
      if (index !== otherIndex) {
        otherElement.classList.add('hidden');
      } else {
        otherElement.classList.add('hovered')
      }
    });
  });

  element.addEventListener('mouseout', () => {
    bannerItems.forEach((otherElement) => {
      otherElement.classList.remove('hovered');
      otherElement.classList.remove('hidden');
    });
  });
});